(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-image-multiple"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', function() {
      const swiper = new Swiper(".before-after-swiper", { // Optional parameters
        slidesPerView: "auto",
        autoplay: { enabled: false},
        loop: true,
        a11y: { enabled: false },
        centeredSlides: true,
        allowTouchMove: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        spaceBetween: 40,
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-image-swiper"] && !Shopify.designMode) return;
  try {
    
  //サムネイル
var sliderThumbnail = new Swiper('.slider-thumbnail', {
  slidesPerView: 4,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
});

//スライダー
var slider = new Swiper('.slider', {
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: sliderThumbnail
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom--category--collection-list-swiper"] && !Shopify.designMode) return;
  try {
    





  var slider = new Swiper('.mySwiper2', {
     slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
     thumbs: {
        swiper: swiper,
       thumbsContainerClass: 'swiper-thumbs',
       multipleActiveThumbs: true,
       
      },
    slideToClickedSlide: true,
    
  });

   var swiper = new Swiper(".mySwiper", {
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
    });

  

  } catch(e) { console.error(e); }
})();
})();
